<template>
<div>
    <div class="game_win_container" v-if="winValueTotal !=null || winValueTip != null">
          <div class="tooltip" id="tooltip" v-show="isShowTool" v-if="winValueTip">
          <div class="tooltip_toast">
            <div class="tooltip_title">{{ $t(`lang.str_game_win_value_total`) }}{{winValueTip}}</div>
          </div>
          <div class="icon"></div>
        </div>
      <div class="game_win_value_total">
        <div class="game_win_value_total_more" v-if="winValueTip"  @click="showTool()">
          <div v-if="isTotalWin"> <img :src="require('../../assets/more_gree.png')" alt=""></div>
          <div v-else><img :src="require('../../assets/more_red.png')" alt=""></div>
        </div>
        <div class="game_win_value_total_text" :style="{ 'width': winValueTip?`90%`:`98%`,'color': isTotalWin?`green`:`red`,'margin-left': winValueTip?`0`:`2%`}" v-if="winValueTotal">
          <span >{{ $t(`lang.str_game_win_value_total`)}}</span>
          {{winValueTotal}}
        </div>
      </div>
     </div>
    <div class="game_describe" v-if="describe_title !=null || describe_message !=null ||describe_content!=null ">
      <div class="game_describe_title" v-if="describe_title !=null">
        {{describe_title}}
      </div>
      <div class="game_describe_content" v-if="describe_content !=null">
        {{describe_content}}
      </div>
      <div class="game_describe_message" v-if="describe_message !=null">
        {{describe_message}}
      </div>
    </div>
    <div class="game_tip"  v-if="tooltip_title !=null || tooltip_message !=null">
      <div class="game_tip_title" v-if="tooltip_title !=null">
        {{tooltip_title}}
      </div>
      <div class="game_tip_message" v-if="tooltip_message !=null">
        {{tooltip_message}}
      </div>
    </div>
</div>
</template>
<script>

import GameTitleLayout from "./game_detail_title.vue";

export default {
    name: "DescribeLayout",
  components: {GameTitleLayout},
    props: {
      winValueTotal:null,
      describe_title:null,
      describe_message:null,
      describe_content:null,
      tooltip_title:null,
      tooltip_message:null,
      isTotalWin:false,
      isShowTool:false,
      winValueTip:null,
    },
    data() {
      return {
      };
    },
    created() {

    },
    methods: {
      showInfo(showTool) {
        this.$emit('showInfo-event', showTool);
      },
      showTool(){
        this.isShowTool = !this.isShowTool;
        this.showInfo(this.isShowTool);
      },
    }
}
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/common/describe_layout.vue